import React from "react";
import PropTypes from 'prop-types';
import Select from "react-select";

function RuleSelection({ ruleType, setActionableResources, updateRuleType, resetState }) {
  const handleTypeUpdate = (type) => {
    setActionableResources(type);
    updateRuleType(type);
    resetState();
  };

  const renderTypeDropdown = () => {
    const options = [
      { value: "Rule::CustomField::CollectionAssociation",
        label: bfTranslate("If custom field added, then move to collection") },
      { value: "Rule::CustomField::SectionAssociation",
        label: bfTranslate("If custom field added, then move to section") },
      { value: "Rule::Label::CollectionAssociation",
        label: bfTranslate("If added to label, then add to collection") },
      { value: "Rule::Section::CollectionAssociation",
        label: bfTranslate("If added to section, then add to collection") },
      { value: "Rule::Tag::CollectionAssociation",
        label: bfTranslate("If tagged, then add to collection") },
      { value: "Rule::Tag::LabelAssociation",
        label: bfTranslate("If tagged, then add to label") },
      { value: "Rule::Tag::SectionAssociation",
        label: bfTranslate("If tagged, then move to section") }
    ];

    if (BFG.hasFeature('watermarking')) {
      options.push({ value: "Rule::Tag::Watermark", label: bfTranslate("If tagged, then watermark") });
    }

    return (
      <Select
        className="select-rule-type"
        clearable={false}
        name="select-rule-type"
        onChange={(option) => handleTypeUpdate(option.value)}
        options={options}
        placeholder={bfTranslate('Select...')}
        searchable={false}
        value={ruleType}
      />
    );
  };

  return (
    <div className="rules-modal-container">
      <span className="bf-label">Select Rule</span>
      {renderTypeDropdown()}
    </div>
  );
}

RuleSelection.propTypes = {
  ruleType: PropTypes.string,
  updateRuleType: PropTypes.func.isRequired,
  setActionableResources: PropTypes.func.isRequired,
  resetState: PropTypes.func.isRequired
};

RuleSelection.defaultProps = {
  ruleType: null
};

export default RuleSelection;
